var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 18.0502V12.3502C7.33325 11.8463 7.54397 11.363 7.91904 11.0067C8.29411 10.6504 8.80282 10.4502 9.33325 10.4502H11.3333C11.8637 10.4502 12.3724 10.6504 12.7475 11.0067C13.1225 11.363 13.3333 11.8463 13.3333 12.3502",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 10.9138V9.50019H19.3333L10.3333 0.950195L1.33325 9.50019H3.33325V16.1502C3.33325 16.6541 3.54397 17.1374 3.91904 17.4937C4.29411 17.85 4.80282 18.0502 5.33325 18.0502H9.85825",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 16.15L15.3333 18.05L19.3333 14.25",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCheck);
export default __webpack_public_path__ + "static/media/home-check.c7abe81f63fef55b3ab1124f1ba2ab1e.svg";
export { ForwardRef as ReactComponent };